import { useRef, useState } from "react";
import Menu from "../Menu/Menu";
import Header from "../Header/Header";
import './Hall.scss';
import { useHallApp } from '../../hooks/useHallApp';
import { useHallEvents } from '../../hooks/useHallEvents';
import { Navigation } from "./Navigation/Navigation";
import useWindowDimensions from "../../hooks/useWindowDimentions";
import { AppProvider } from "../../contexts/AppContext";

interface HallProps {
  isSceneLoaded: boolean;
  setIsSceneLoaded: (value: boolean) => void;
}

export const Hall: React.FC<HallProps> = ({
  setIsSceneLoaded
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const app = useHallApp(containerRef, setIsSceneLoaded);
  const windowDimensions = useWindowDimensions();
  const [activePortal, setActivePortal] = useState<string | null>(null);

  useHallEvents(app, setActivePortal);

  return (
    <AppProvider app={app}>
      <Header />
      <div className="app app-hall" ref={containerRef} id="app" style={{ width: '100%', height: '100vh' }}>
      </div>
      {windowDimensions.width > 768 && (
        <Navigation activePortal={activePortal}/>
      )}
      <Menu
        menuType="hall"
      />
    </AppProvider>
  );
};